var _excluded = ["children", "showMoreDetails", "showMoreType", "hasCenteredShowMore", "breakpoint", "heightBreakpoint", "hasContainer"];
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useCallback, useContext, useEffect, useState, useRef } from "react";
import loadable from "@loadable/component";
import styled, { css } from "styled-components";
import OnColorContext from "../../../contexts/OnColorContext";
import ResizeDetector from "../../../helpers/ResizeDetector";
import useBreakpoint from "../../../hooks/useBreakpoint";
import { animationDuration } from "../../../settings";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
import ButtonAtm from "../../atoms/ButtonAtm";
import LinkAtm from "../../atoms/LinkAtm";
import AlignContentOrg from "../AlignContentOrg";
import ContainerOrg from "../ContainerOrg";
var AnimateHeight = loadable(function () {
  return import("react-animate-height");
});

/**
 * 1. Using rgba() instead of 'transparency' due to iOS Safari bug
 */

export var defaultProps = {
  heightBreakpoint: "default",
  showMoreType: "button"
};
var heightBreakpointValues = {
  "default": 2000,
  templates: 2090,
  medium: 1200,
  "short": 600
};
var visibleContentRatio = 0.7;
var Wrapper = styled.div.withConfig({
  componentId: "sc-1sw8gig-0"
})(["position:relative;"]);
export var ShowMoreContainer = styled.div.withConfig({
  componentId: "sc-1sw8gig-1"
})(function (_ref) {
  var $onColor = _ref.$onColor,
    theme = _ref.theme;
  return css(["position:absolute;z-index:1;right:0;bottom:0;left:0;padding-top:", ";background:", ";&::before{content:\"\";position:absolute;right:0;bottom:100%;left:0;height:", ";background:linear-gradient( rgba(255,255,255,0),", " );}"], space(2), getColor(theme, $onColor), space(20), getColor(theme, $onColor));
});
function ExpandableContentOrg(_ref2) {
  var children = _ref2.children,
    showMoreDetails = _ref2.showMoreDetails,
    _ref2$showMoreType = _ref2.showMoreType,
    showMoreType = _ref2$showMoreType === void 0 ? defaultProps.showMoreType : _ref2$showMoreType,
    hasCenteredShowMore = _ref2.hasCenteredShowMore,
    breakpoint = _ref2.breakpoint,
    _ref2$heightBreakpoin = _ref2.heightBreakpoint,
    heightBreakpoint = _ref2$heightBreakpoin === void 0 ? defaultProps.heightBreakpoint : _ref2$heightBreakpoin,
    hasContainer = _ref2.hasContainer,
    restProps = _objectWithoutProperties(_ref2, _excluded);
  var onColor = useContext(OnColorContext);
  var isLargeUp = useBreakpoint("large");
  var contentRef = useRef(null);
  var shouldContentBeExpandable = useBreakpoint(breakpoint ? breakpoint.from : "small", breakpoint === null || breakpoint === void 0 ? void 0 : breakpoint.to);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasHiddenContent = _useState2[0],
    setHasHiddenContent = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasContentBeenExpanded = _useState4[0],
    setHasContentBeenExpanded = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    contentHeight = _useState6[0],
    setContentHeight = _useState6[1];
  var setIfContentShouldBeHidden = useCallback(function () {
    var result = false;
    if (shouldContentBeExpandable) {
      result = (contentHeight !== null && contentHeight !== void 0 ? contentHeight : 0) >= heightBreakpointValues[heightBreakpoint];
    }
    setHasHiddenContent(result);
  }, [shouldContentBeExpandable, heightBreakpoint, contentHeight]);
  var handleShowMoreClick = function handleShowMoreClick(event) {
    event.preventDefault();
    if (showMoreDetails !== null && showMoreDetails !== void 0 && showMoreDetails.onClick) {
      showMoreDetails.onClick();
    }
    setHasHiddenContent(false);
    setHasContentBeenExpanded(true);
  };
  useEffect(function () {
    if (contentRef.current) {
      setContentHeight(contentRef.current.clientHeight);
    }
  }, [contentRef, setContentHeight]);
  useEffect(function () {
    if (!hasContentBeenExpanded) {
      setIfContentShouldBeHidden();
    }
  }, [hasContentBeenExpanded, setIfContentShouldBeHidden]);
  var showMoreButtonJsx = /*#__PURE__*/React.createElement(ButtonAtm, {
    color: "secondary",
    variant: "outlined",
    size: isLargeUp ? "default" : "small",
    isExpanded: !isLargeUp,
    title: showMoreDetails.title,
    onClick: handleShowMoreClick
  }, showMoreDetails.text);
  var showMoreLinkJsx = /*#__PURE__*/React.createElement(LinkAtm, {
    title: showMoreDetails.title,
    onClick: handleShowMoreClick,
    typography: "small4",
    href: "#"
  }, showMoreDetails.text);
  var cta = showMoreType === "button" ? showMoreButtonJsx : showMoreLinkJsx;
  var showMoreJsx = hasCenteredShowMore ? /*#__PURE__*/React.createElement(AlignContentOrg, {
    horizontalAlign: "center"
  }, cta) : cta;
  var ctaContainerJsx;
  if (hasContainer) {
    ctaContainerJsx = /*#__PURE__*/React.createElement(ShowMoreContainer, {
      $onColor: onColor
    }, /*#__PURE__*/React.createElement(ContainerOrg, null, showMoreJsx));
  } else {
    ctaContainerJsx = /*#__PURE__*/React.createElement(ShowMoreContainer, {
      $onColor: onColor
    }, showMoreJsx);
  }
  var contentJsx = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ResizeDetector, {
    setHeight: setContentHeight
  }, /*#__PURE__*/React.createElement("div", {
    ref: contentRef
  }, children)), hasHiddenContent ? ctaContainerJsx : null);
  return /*#__PURE__*/React.createElement(Wrapper, restProps, /*#__PURE__*/React.createElement(AnimateHeight, {
    height: hasHiddenContent ? heightBreakpointValues[heightBreakpoint] * visibleContentRatio : "auto",
    duration: hasHiddenContent || !shouldContentBeExpandable ? 0 : animationDuration.slow,
    fallback: contentJsx
  }, contentJsx));
}
export default ExpandableContentOrg;